var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('loading-overlay', {
    attrs: {
      "wait-for": true
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };